const HomePage = () => {
  return (
    <div style={{ backgroundColor: 'blue' }}>
      <h1>ini Home PAGE</h1> ini Home PAGE
    </div>
  )
}

export default HomePage
